const HTML_TAG_PATTERN = /<[a-z][\s\S]*>/i;

/** Detects whether a string contains HTML markup, so plain text keeps rendering unchanged
 *  and only tagged content opts into being rendered as live HTML. */
export function containsHtml(text: string): boolean {
  return HTML_TAG_PATTERN.test(text);
}
